// source: pbtypes/gen/vehicle_params_for_phone/subject_params.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_planner_subject_focus_settings_pb = require('../../../pbtypes/gen/planner/subject_focus_settings_pb.js');
goog.object.extend(proto, pbtypes_gen_planner_subject_focus_settings_pb);
goog.exportSymbol('proto.vehicle_params_for_phone.SubjectParams', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vehicle_params_for_phone.SubjectParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vehicle_params_for_phone.SubjectParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vehicle_params_for_phone.SubjectParams.displayName = 'proto.vehicle_params_for_phone.SubjectParams';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vehicle_params_for_phone.SubjectParams.prototype.toObject = function(opt_includeInstance) {
  return proto.vehicle_params_for_phone.SubjectParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_params_for_phone.SubjectParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vehicle_params_for_phone.SubjectParams.toObject = function(includeInstance, msg) {
  var f, obj = {
initialSettings: (f = msg.getInitialSettings()) && pbtypes_gen_planner_subject_focus_settings_pb.SubjectFocusSettings.toObject(includeInstance, f),
minElevation: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
maxElevation: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
minRange: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
maxRange: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_params_for_phone.SubjectParams}
 */
proto.vehicle_params_for_phone.SubjectParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vehicle_params_for_phone.SubjectParams;
  return proto.vehicle_params_for_phone.SubjectParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_params_for_phone.SubjectParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_params_for_phone.SubjectParams}
 */
proto.vehicle_params_for_phone.SubjectParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_planner_subject_focus_settings_pb.SubjectFocusSettings;
      reader.readMessage(value,pbtypes_gen_planner_subject_focus_settings_pb.SubjectFocusSettings.deserializeBinaryFromReader);
      msg.setInitialSettings(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinElevation(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxElevation(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinRange(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxRange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vehicle_params_for_phone.SubjectParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vehicle_params_for_phone.SubjectParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_params_for_phone.SubjectParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vehicle_params_for_phone.SubjectParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInitialSettings();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_gen_planner_subject_focus_settings_pb.SubjectFocusSettings.serializeBinaryToWriter
    );
  }
  f = message.getMinElevation();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getMaxElevation();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getMinRange();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getMaxRange();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
};


/**
 * optional planner.SubjectFocusSettings initial_settings = 1;
 * @return {?proto.planner.SubjectFocusSettings}
 */
proto.vehicle_params_for_phone.SubjectParams.prototype.getInitialSettings = function() {
  return /** @type{?proto.planner.SubjectFocusSettings} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_planner_subject_focus_settings_pb.SubjectFocusSettings, 1));
};


/**
 * @param {?proto.planner.SubjectFocusSettings|undefined} value
 * @return {!proto.vehicle_params_for_phone.SubjectParams} returns this
*/
proto.vehicle_params_for_phone.SubjectParams.prototype.setInitialSettings = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle_params_for_phone.SubjectParams} returns this
 */
proto.vehicle_params_for_phone.SubjectParams.prototype.clearInitialSettings = function() {
  return this.setInitialSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vehicle_params_for_phone.SubjectParams.prototype.hasInitialSettings = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional double min_elevation = 2;
 * @return {number}
 */
proto.vehicle_params_for_phone.SubjectParams.prototype.getMinElevation = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_params_for_phone.SubjectParams} returns this
 */
proto.vehicle_params_for_phone.SubjectParams.prototype.setMinElevation = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double max_elevation = 3;
 * @return {number}
 */
proto.vehicle_params_for_phone.SubjectParams.prototype.getMaxElevation = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_params_for_phone.SubjectParams} returns this
 */
proto.vehicle_params_for_phone.SubjectParams.prototype.setMaxElevation = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double min_range = 4;
 * @return {number}
 */
proto.vehicle_params_for_phone.SubjectParams.prototype.getMinRange = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_params_for_phone.SubjectParams} returns this
 */
proto.vehicle_params_for_phone.SubjectParams.prototype.setMinRange = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double max_range = 5;
 * @return {number}
 */
proto.vehicle_params_for_phone.SubjectParams.prototype.getMaxRange = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_params_for_phone.SubjectParams} returns this
 */
proto.vehicle_params_for_phone.SubjectParams.prototype.setMaxRange = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


goog.object.extend(exports, proto.vehicle_params_for_phone);
